import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'meetingAnalysisDuration',
  standalone: true,
})
export class Duration implements PipeTransform {
  transform(seconds: number): string {
    const d = new Date(0, 0, 0, 0, 0, 0, 0).setSeconds(seconds);
    if (seconds || 0 < 3600) {
      return new DatePipe('en-US').transform(d, 'mm:ss') || '';
    } else {
      return new DatePipe('en-US').transform(d, 'hh:mm:ss') || '';
    }
  }
}
